import { render, staticRenderFns } from "./Paso3.vue?vue&type=template&id=8444d052&scoped=true"
import script from "./Paso3.vue?vue&type=script&lang=js"
export * from "./Paso3.vue?vue&type=script&lang=js"
import style0 from "./Paso3.vue?vue&type=style&index=0&id=8444d052&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8444d052",
  null
  
)

export default component.exports